<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 8.5L12 15.5L5 8.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
